import {
    GET_PERSONAL_CLAIMS,
    GET_COMMERCIAL_CLAIMS,
    GET_CLAIM_SUMMARY,
    GET_AGENT_CLAIMS,
    SET_ACTIVE_CLAIM
} from "../actions/claims";

const initialState = {
    personalClaims: null,
    commercialClaims: null,
    claimSummary: null,
    activeClaim: null
};

export const claimsReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_PERSONAL_CLAIMS:
            return {...state, personalClaims: action.claims};
        case GET_COMMERCIAL_CLAIMS:
            return {...state, commercialClaims: action.claims};
        case GET_AGENT_CLAIMS:
            return {...state, claims: action.claims};
        case GET_CLAIM_SUMMARY:
            return {...state, claimSummary: action.claimSummary};
        case SET_ACTIVE_CLAIM:
            return {...state, activeClaim: action.claimNumber};
        default:
            return {...state};
    }
};